import { TextField as FMTextField } from '@cibo/ui'
import { FormControl, FormLabel, InputAdornment } from '@mui/material'
import { Field } from 'formik'
import { useTranslation } from 'react-i18next'
import { DetailEditorPropsByYear } from '../types'

export const BiomassBurningInputEditorSimple = ({
  name = 'biomassBurning',
  year,
}: DetailEditorPropsByYear) => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningEditor')

  return (
    <FormControl required style={{ paddingBottom: 16 }}>
      <FormLabel htmlFor={`${name}.percentage`}>{t('percentBurned')}</FormLabel>

      <Field
        component={FMTextField}
        name={`${name}.percentage`}
        InputProps={{
          type: 'number',
          inputProps: {
            step: 1,
            min: 0,
            'data-testid': `${name}.percentage`,
          },
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
      />
    </FormControl>
  )
}
